function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createRef } from 'react';

/**
 * Takes errorData object with title, message, and more_info keys as props. The
 * component displays a tailwind modal when mounted. errorData.title is used
 * to set modal title. errorData.message is inserted as HTML text in modal
 * body. And errorData.more_info is shown using a pre tag in modal body.
 *
 * The displayed modal dialog cannot be dismissed.
 * The user must close the tab or press back button to go back to search form.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ErrorModal = /*#__PURE__*/function (_React$Component) {
  function ErrorModal(props) {
    var _this;
    _classCallCheck(this, ErrorModal);
    _this = _callSuper(this, ErrorModal, [props]);
    /**
     * Shows error viewer.
     */
    _defineProperty(_this, "show", function (errorData, beforeShow) {
      _this.setState({
        errorData: errorData
      });

      // Caller can specify an amount of time to wait for before showing the
      // modal. This is helpful if the caller wants to finish some work
      // before showing error modal.
      setTimeout(function () {
        var _this$modalRef$curren;
        (_this$modalRef$curren = _this.modalRef.current) === null || _this$modalRef$curren === void 0 || _this$modalRef$curren.showModal();
      }, beforeShow || 0);
    });
    /**
     * Hide dialogue.
     */
    _defineProperty(_this, "hide", function () {
      var _this$modalRef$curren2;
      (_this$modalRef$curren2 = _this.modalRef.current) === null || _this$modalRef$curren2 === void 0 || _this$modalRef$curren2.close();
    });
    _this.state = {
      errorData: {},
      isModalVisible: false
    };
    _this.modalRef = /*#__PURE__*/createRef();
    return _this;
  }
  _inherits(ErrorModal, _React$Component);
  return _createClass(ErrorModal, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        isModalVisible = _this$state.isModalVisible,
        errorData = _this$state.errorData;
      return /*#__PURE__*/_jsx("div", {
        className: "relative",
        children: /*#__PURE__*/_jsx("dialog", {
          ref: this.modalRef,
          className: "fixed p-4 w-full max-w-2xl bg-transparent focus:outline-none",
          children: /*#__PURE__*/_jsxs("div", {
            className: "relative flex flex-col rounded-lg bg-white shadow",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex items-start justify-between rounded-t border-b p-5",
              children: [/*#__PURE__*/_jsx("h3", {
                className: "text-xl font-medium text-gray-900",
                children: errorData.title
              }), /*#__PURE__*/_jsx("button", {
                className: "ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-gray-400 hover:bg-gray-200",
                onClick: this.hide,
                children: /*#__PURE__*/_jsx("i", {
                  className: "fa-solid fa-xmark hover:text-black"
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "pt-2 px-6 pb-6 mt-2 text-sm",
              children: [/*#__PURE__*/_jsx("p", {
                dangerouslySetInnerHTML: {
                  __html: errorData.message
                },
                className: "mb-4"
              }), errorData.more_info && /*#__PURE__*/_jsx("pre", {
                className: "p-2 bg-slate-200 overflow-auto max-h-56",
                children: errorData.more_info
              })]
            })]
          })
        })
      });
    }
  }]);
}(React.Component);
export { ErrorModal as default };